import { useEffect, useState } from "react";

/**
 * How long an Undo or Redo may take before its button shows a spinner. A step whose card is ready
 * lands well within it (the rollback or replay is a local write), and a spinner that appears for
 * a frame or two before the card slides in reads as a glitch, not as progress.
 */
const HISTORY_STEP_SPINNER_DELAY_MS = 150;

/** Whether a history step has been waiting long enough to show its spinner. */
export function useHistoryStepSpinner(isWaiting: boolean): boolean {
  const [hasLingered, setHasLingered] = useState(false);
  if (!isWaiting && hasLingered) {
    setHasLingered(false);
  }
  useEffect(() => {
    if (!isWaiting) {
      return;
    }
    const timer = setTimeout(setHasLingered, HISTORY_STEP_SPINNER_DELAY_MS, true);
    return () => clearTimeout(timer);
  }, [isWaiting]);
  return isWaiting && hasLingered;
}
